<template>
  <b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
    <div>
      <CRow>
        <CCol>
          <CSelect
              prepend="Uporabnik:"
              placeholder="Izberite uporabnika"
              :options="users"
              :value.sync="modalAbsence.user_id"
              custom
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <div class="form-group">
            <b-form-checkbox v-model="modalAbsence.single_day" switch>
              Enodnevna odsotnost
            </b-form-checkbox>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <v-date-picker
              locale="sl-SI"
              v-model="modalAbsence.start_date"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  :label="modalAbsence.single_day ? 'Datum' : 'Začetni datum'"
                  :value="inputValue"
                  v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </CCol>
        <CCol>
          <v-date-picker
              locale="sl-SI"
              v-model="modalAbsence.end_date"
              v-if="!modalAbsence.single_day"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Končni datum"
                  :value="inputValue"
                  v-on="inputEvents"/>
            </template>
          </v-date-picker>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CSelect
              prepend="Razlog:"
              placeholder="Izberite razlog"
              :options="absenceReasons"
              :value.sync="modalAbsence.reason"
              custom
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CTextarea
              label="Opomba"
              rows="3"
              v-model="modalAbsence.note"/>
        </CCol>
      </CRow>

      <CRow v-if="showTasksActionRadios">
        <CCol>

          <div class="form-group task-action-radio-buttons">
            <label>Akcija za naloge med odsotnostjo:</label>
            <b-form-radio-group
                v-model="modalAbsence.tasks_action"
                :options="[
                  { value: 'reassign', text: 'Prenesi na druge uporabnike' },
                  { value: 'cancel', text: 'Prekliči naloge' },
                  { value: 'postpone', text: 'Preloži naloge na kasnejši čas' }
                ]"
                name="tasks_action"
                buttons
                button-variant="outline-primary"
                class="mb-2"
            />
          </div>
        </CCol>
      </CRow>

      <CRow v-if="showTasksActionRadios && modalAbsence.tasks_action === 'reassign'">
        <CCol>
          <CSelect
              label="Izberi zamenjavo:"
              placeholder="Izberite delavca"
              :options="availableUsers"
              :value.sync="modalAbsence.replacement_user_id"
              custom
          >
            <template #prepend-content>
              <span v-if="loadingAvailableUsers" class="spinner-border spinner-border-sm mr-2"></span>
            </template>
          </CSelect>
          <small class="text-muted" v-if="availableUsers.length > 0">
            Delavci so razvrščeni po razpoložljivosti v 48 urah po koncu odsotnosti
          </small>
          <small class="text-warning" v-if="!modalAbsence.user_id || !modalAbsence.end_date">
            Izberite zaposlenega in končni datum odsotnosti za prikaz razpoložljivih delavcev
          </small>
        </CCol>
      </CRow>

    </div>
    <CAlert v-show="message.text != null" :color="message.type">
      {{ message.text }}
    </CAlert>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <b-container fluid class="p-0">
        <b-row>
          <b-col align-self="end" class="ma_pos">
            <b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
            <b-button :disabled="okButton.disabled || !isFormValid" :title="isFormValid ? '' : 'Preverite vnos podatkov'" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <vue-loading :active.sync="isLoading" :is-full-page="false"/>
  </b-modal>
</template>

<script>
import { ABSENCE_CREATE_EDIT } from "@/store/actions/absences";
import {USERS_LIST} from "@/store/actions/users";
import viewDate from "@/filters/viewDate";
import AbsencesService from "@/services/absences";

export default {
  name: 'absence-create-edit-modal',
  components: {
  },
  props: {
  },
  methods: {
    showModal: function (modalInput) {
      /*
        mode 1 => Create
        mode 2 => Edit
      */
      this.mode = modalInput.mode;
      this.initModal(modalInput.modalAbsence);
    },
    initModal: function (modalAbsence) {
      if (this.mode === this.mode_CREATE1) {
        this.title = 'Dodajanje odsotnosti';
        this.okButton.label = 'Dodaj';
      } else if (this.mode === this.mode_EDIT2) {
        this.title = 'Odsotnost pri urejanju (#' + modalAbsence.id + ')';
        this.initAbsence(modalAbsence);
        this.okButton.label = 'Shrani';
      } else {
        this.mode = this.mode_UNKNOWN0;
        this.title = 'Neznan način';
        this.okButton.label = 'Zapri';
      }
      this.$refs.modal.show();
    },
    initAbsence: function (modalAbsence) {
      this.modalAbsence.id = modalAbsence.id;
      this.modalAbsence.user_id = modalAbsence.user_id;
      this.modalAbsence.start_date = modalAbsence.start_date;
      this.modalAbsence.end_date = modalAbsence.end_date;
      this.modalAbsence.reason = modalAbsence.reason;
      this.modalAbsence.note = modalAbsence.note;
      this.modalAbsence.single_day = modalAbsence.start_date === modalAbsence.end_date;
      this.modalAbsence.old_user_id = modalAbsence.user_id;
      this.modalAbsence.old_start_date = modalAbsence.start_date;
      this.modalAbsence.old_end_date = modalAbsence.end_date;
    },
    onOkModal: function () {
      this.startProgress();
      const modalAbsence = this.modalAbsence;
      this.$store.dispatch(ABSENCE_CREATE_EDIT, { modalAbsence })
          .then((responseData) => {
            this.stopProgress();
            this.$emit('emit_absenceCreatedOrEdited', responseData);
            this.$refs.modal.hide();
          })
          .catch(error => {
            this.stopProgress();
            console.error(error);
            if(error.response && error.response.data && error.response.data.code) {
              if (this.mode === this.mode_CREATE1) {
                this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ' - ' +  error.response.data.message + ')', this.ALERT_TYPE_ERROR);
              } else if (this.mode === this.mode_EDIT2) {
                this.showAlert('Napaka pri urejanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
              } else {
                this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
              }
            } else {
              this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
            }
          });
    },
    clearModalData: function () {
      this.isLoading = false;
      this.title = '';
      this.okButton = {
        label: 'Shrani',
        progress: false,
        disabled: false
      };
      this.showAlert();
      this.mode = 0;
      this.modalAbsence.id = 0;
      this.modalAbsence.user_id = null;
      this.modalAbsence.start_date = '';
      this.modalAbsence.end_date = '';
      this.modalAbsence.reason = 0;
      this.modalAbsence.note = null;
      this.modalAbsence.single_day = false;
      this.modalAbsence.tasks_action = 'reassign';
      this.modalAbsence.replacement_user_id = null;
      this.modalAbsence.old_user_id = null;
      this.modalAbsence.old_start_date = '';
      this.modalAbsence.old_end_date = '';
      this.availableUsers = [];
      this.loadingAvailableUsers = false;
    },
    startProgress: function () {
      this.isLoading = true;
      this.okButton.disabled = true;
      this.okButton.progress = true;
    },
    stopProgress: function () {
      this.isLoading = false;
      this.okButton.disabled = false;
      this.okButton.progress = false;
    },
    showAlert: function (message, type, seconds) {
      if (message && type && seconds) {
        this.message.type = type;
        this.message.text = message;
        setTimeout(() => {
          this.showAlert();
        }, seconds * 1000);
      } else if (message && type) {
        this.message.type = type;
        this.message.text = message;
      } else if (message) {
        this.message.type = 'primary';
        this.message.text = message;
      } else {
        this.message.type = null;
        this.message.text = null;
      }
    },
    async fetchAvailableUsers() {
      // Only fetch if both user and end date are selected
      if (!this.modalAbsence.user_id || !this.modalAbsence.end_date) {
        this.availableUsers = [];
        return;
      }

      this.loadingAvailableUsers = true;
      this.availableUsers = [];

      try {
        const response = await AbsencesService.getAvailableUsers({
          absentUserId: this.modalAbsence.user_id,
          absenceEndDate: this.modalAbsence.end_date,
          hours: 48
        });

        this.availableUsers = response.users.map(user => {
          const busyHours = user.assigned_hours;
          const totalHours = user.total_working_hours;
          const percentage = user.utilization_percentage;
          const absenceNote = user.has_absence ? ', ima odsotnost' : '';

          return {
            value: user.id,
            label: `${user.name} - ${busyHours}h / ${totalHours}h (${percentage}%)${absenceNote}`
          };
        });
      } catch (error) {
        console.error('Error fetching available users:', error);
        console.error('Error response:', error.response);
        const errorMsg = error.response?.data?.error || error.message || 'Napaka pri nalaganju razpoložljivih delavcev';
        this.showAlert(errorMsg, this.ALERT_TYPE_ERROR);
      } finally {
        this.loadingAvailableUsers = false;
      }
    }
  },
  data: function () {
    return {
      isLoading: false,
      title: '',
      okButton: {
        label: 'Shrani',
        progress: false,
        disabled: false
      },
      message: {
        type: null,
        text: null
      },
      ALERT_TYPE_SUCCESS: 'success',
      ALERT_TYPE_ERROR: 'danger',
      mode_UNKNOWN0: 0,
      mode_CREATE1: 1,
      mode_EDIT2: 2,
      mode: 0,
      modalAbsence: {
        id: 0,
        user_id: null,
        start_date: '',
        end_date: '',
        reason: 0,
        note: null,
        single_day: false,
        tasks_action: 'reassign',
        replacement_user_id: null,
        old_user_id: null,
        old_start_date: '',
        old_end_date: '',
      },
      availableUsers: [],
      loadingAvailableUsers: false,
      absenceReasons: [
        {
          value: 0,
          label: "Neznano"
        },
        {
          value: 1,
          label: "Dopust"
        },
        {
          value: 2,
          label: "Bolniški dopust"
        }
      ]
    }
  },
  computed: {
    modalSize () {
      return 'md';
    },
    isFormValid() {
      return this.isValidUserId
          && this.isValidStartDate
          && this.isValidEndDate
          && this.isValidDateOrder;
    },
    isValidUserId() {
      return !!this.modalAbsence.user_id;
    },
    isValidStartDate() {
      return !!this.modalAbsence.start_date;
    },
    isValidEndDate() {
      return !!this.modalAbsence.end_date;
    },
    isValidDateOrder() {
      const startDate = new Date(this.modalAbsence.start_date);
      const endDate = new Date(this.modalAbsence.end_date);
      return startDate <= endDate;
    },
    users() {
      return this.$store
          .getters
          .getUsers
          .filter(user => user.roles.some(role => ['licar', 'klepar'].includes(role.name)))
          .map(user => ({
            value: user.id,
            label: user.name
          }))
          .sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    },
    showTasksActionRadios() {
      if (this.mode === this.mode_CREATE1) {
        return true;
      }

      if (this.mode === this.mode_EDIT2) {
        let res = (
            this.modalAbsence.user_id !== this.modalAbsence.old_user_id ||
            viewDate(this.modalAbsence.start_date) !== viewDate(this.modalAbsence.old_start_date) ||
            viewDate(this.modalAbsence.end_date) !== viewDate(this.modalAbsence.old_end_date)
        );
        return res;
      }
      return false;
    }
  },
  watch: {
    'modalAbsence.single_day'(val) {
      if (val) {
        this.modalAbsence.end_date = this.modalAbsence.start_date;
      }
    },
    'modalAbsence.start_date'(val) {
      if (this.modalAbsence.single_day) {
        this.modalAbsence.end_date = val;
      }
      if (this.mode === this.mode_EDIT2) {
        if (
            this.modalAbsence.user_id === this.modalAbsence.old_user_id &&
            viewDate(this.modalAbsence.start_date) === viewDate(this.modalAbsence.old_start_date) &&
            viewDate(this.modalAbsence.end_date) === viewDate(this.modalAbsence.old_end_date)
        ) {
          this.modalAbsence.tasks_action = null;
        } else {
          this.modalAbsence.tasks_action = 'reassign';
        }
      }
    },
    'modalAbsence.end_date'(val) {
      if (this.mode === this.mode_EDIT2) {
        if (
            this.modalAbsence.user_id === this.modalAbsence.old_user_id &&
            viewDate(this.modalAbsence.start_date) === viewDate(this.modalAbsence.old_start_date) &&
            viewDate(this.modalAbsence.end_date) === viewDate(this.modalAbsence.old_end_date)
        ) {
          this.modalAbsence.tasks_action = null;
        } else {
          this.modalAbsence.tasks_action = 'reassign';
        }
      }
      // Refetch available users when end date changes (affects availability calculation)
      if (val && this.modalAbsence.user_id && this.modalAbsence.tasks_action === 'reassign') {
        this.fetchAvailableUsers();
      }
    },
    'modalAbsence.user_id'(val) {
      if (this.mode === this.mode_EDIT2) {
        if (
            this.modalAbsence.user_id === this.modalAbsence.old_user_id &&
            viewDate(this.modalAbsence.start_date) === viewDate(this.modalAbsence.old_start_date) &&
            viewDate(this.modalAbsence.end_date) === viewDate(this.modalAbsence.old_end_date)
        ) {
          this.modalAbsence.tasks_action = null;
        } else {
          this.modalAbsence.tasks_action = 'reassign';
        }
      }
      // Fetch available users only if both user and end date are selected and action is reassign
      if (val && this.modalAbsence.end_date && this.modalAbsence.tasks_action === 'reassign') {
        this.fetchAvailableUsers();
      }
    },
    'modalAbsence.tasks_action'(val) {
      if (val === 'reassign' && this.modalAbsence.user_id && this.modalAbsence.end_date) {
        this.fetchAvailableUsers();
      } else {
        this.availableUsers = [];
        this.modalAbsence.replacement_user_id = null;
      }
    }
  },
  created () {
    this.$store.dispatch(USERS_LIST);
  }
}
</script>

<style>
.task-action-radio-buttons label.btn span {
  font-size: 11px;
}
</style>

<style scoped>
.ma_pos {
  text-align: end;
}
</style>